import { useQuery } from '@tanstack/react-query'
import { useAuth } from './useAuth'
import { throwOnError } from '../utils/throwOnError'

export const useGetBatchDataQuery = (isEnabled = true) => {
  const { authFetch } = useAuth()
  return useQuery({
    refetchOnWindowFocus: 'always',
    enabled: isEnabled,
    queryKey: ['batch'],
    queryFn: async () => {
      const { data, error } = await authFetch().GET('/batch')
      if (error) {
        throwOnError(error)
      }
      return data
    }
  })
}
